import { render } from "./MusicPage.vue?vue&type=template&id=e63b852c"
import script from "./MusicPage.vue?vue&type=script&lang=js"
export * from "./MusicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__